import { Injectable } from '@angular/core';
import { BehaviorSubject, tap } from 'rxjs';
import { StoreResource, StoreFilters } from '../resource/store.resource';
import { GraphMap } from '../interfaces/graph-node.interface';

@Injectable({ providedIn: 'root' })
export class StoreService {
  public publishedMapsSubject = new BehaviorSubject<GraphMap[]>([]);
  public userLibrarySubject = new BehaviorSubject<GraphMap[]>([]);
  public storeChangedSubject = new BehaviorSubject<void>(undefined);

  constructor(private resource: StoreResource) {}

  public getPublishedMaps(filters?: StoreFilters) {
    return this.resource.getPublishedMaps(filters).pipe(
      tap(maps => this.publishedMapsSubject.next(maps))
    );
  }

  public publishMap(mapId: string, thumbnailUrl?: string) {
    return this.resource.publishMap(mapId, thumbnailUrl).pipe(
      tap(() => this.storeChangedSubject.next())
    );
  }

  public unpublishMap(mapId: string) {
    return this.resource.unpublishMap(mapId).pipe(
      tap(() => this.storeChangedSubject.next())
    );
  }

  public addToLibrary(mapId: string) {
    return this.resource.addToLibrary(mapId).pipe(
      tap(() => {
        this.storeChangedSubject.next();
        this.refreshUserLibrary();
      })
    );
  }

  public removeFromLibrary(mapId: string) {
    return this.resource.removeFromLibrary(mapId).pipe(
      tap(() => {
        this.storeChangedSubject.next();
        this.refreshUserLibrary();
      })
    );
  }

  public getUserLibrary() {
    return this.resource.getUserLibrary().pipe(
      tap(maps => this.userLibrarySubject.next(maps))
    );
  }

  public refreshUserLibrary() {
    this.getUserLibrary().subscribe();
  }

  public isInLibrary(mapId: string) {
    return this.resource.isInLibrary(mapId);
  }

  public isPublished(mapId: string) {
    return this.resource.isPublished(mapId);
  }

  public isMapInUserLibrary(mapId: string): boolean {
    return this.userLibrarySubject.value.some(m => m.id === mapId);
  }
}
